export default __webpack_public_path__ + "static/media/ThirdView Preview.b7f02520.png";